import {Currencies} from 'api/generated';
import React, {useState} from 'react';
import {ReportsOverview} from 'routes/Dashboard/ReportsOverview';
import {TodayChart} from 'routes/Dashboard/TodayChart';

export const MasterAccountAnalytics: React.FC<any> = ({masterAccountId}) => {
  const [currency, setCurrency] = useState<Currencies>(Currencies.EUR);
  return (
    <>
      <TodayChart
        filterBy={'masterAccountId'}
        filterValue={masterAccountId}
        selectedCurrency={currency}
        setCurrency={setCurrency}
      />
      <ReportsOverview
        filterBy={'masterAccountId'}
        filterValue={masterAccountId}
        selectedCurrency={currency}
      />
    </>
  );
};
